import { render, staticRenderFns } from "./tags-template.vue?vue&type=template&id=7cd90b61&scoped=true&"
import script from "./tags-template.vue?vue&type=script&lang=js&"
export * from "./tags-template.vue?vue&type=script&lang=js&"
import style0 from "./tags-template.vue?vue&type=style&index=0&id=7cd90b61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd90b61",
  null
  
)

export default component.exports